import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getProducts } from '../services/api';
import './Products.css';

function Products() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        setLoading(true);
        const data = await getProducts();
        console.log('[Frontend] Raw API response:', data);
        console.log('[Frontend] Response type:', typeof data);
        console.log('[Frontend] Is array?', Array.isArray(data));
        
        // Handle different response structures
        let productsArray = [];
        if (Array.isArray(data)) {
          productsArray = data;
        } else if (data?.data && Array.isArray(data.data)) {
          productsArray = data.data;
        } else if (data?.products && Array.isArray(data.products)) {
          productsArray = data.products;
        }
        
        console.log('[Frontend] Products array:', productsArray);
        setProducts(productsArray);
        setLoading(false);
      } catch (err) {
        console.error('Failed to fetch products:', err);
        setError(err.message);
        setLoading(false);
      }
    };

    fetchProducts();
  }, []);

  const filteredProducts = products.filter(product =>
    (product.title || product.name || '').toLowerCase().includes(searchTerm.toLowerCase())
  );

  if (loading) {
    return (
      <div className="products-page">
        <div className="container">
          <div className="loading">
            <div className="spinner"></div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="products-page">
      <div className="container">
        <div className="products-header">
          <h1>All Products</h1>
          <p>Browse our complete collection of gaming tools</p>
        </div>

        <div className="products-controls">
          <input
            type="text"
            placeholder="Search products..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="search-input"
          />
        </div>

        {error || products.length === 0 ? (
          <div className="no-products-message">
            <div className="placeholder-card">
              <div className="placeholder-icon">🎮</div>
              <h2>No Products Yet</h2>
              <p>We're setting up our store. Products will be available soon!</p>
              <Link to="/" className="btn btn-primary">Back to Home</Link>
            </div>
          </div>
        ) : (
          <>
            {filteredProducts.length === 0 ? (
              <div className="no-results">
                <p>No products found matching "{searchTerm}"</p>
              </div>
            ) : (
              <div className="products-list">
                {filteredProducts.map((product) => (
                  <ProductCard key={product.id} product={product} />
                ))}
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}

function ProductCard({ product }) {
  // Get price from variants if product price is null
  const getPrice = () => {
    if (product.price) {
      return parseFloat(product.price).toFixed(2);
    }
    if (product.variants && product.variants.length > 0) {
      // Get lowest price from variants
      const prices = product.variants.map(v => parseFloat(v.price || 0));
      const minPrice = Math.min(...prices);
      const maxPrice = Math.max(...prices);
      
      if (minPrice === maxPrice) {
        return minPrice.toFixed(2);
      }
      return `${minPrice.toFixed(2)} - ${maxPrice.toFixed(2)}`;
    }
    return '0.00';
  };

  const getVariantCount = () => {
    if (product.variants && product.variants.length > 1) {
      return ` (${product.variants.length} variants)`;
    }
    return '';
  };

  return (
    <Link to={`/products/${product.id}`} className="product-card card">
      <div className="product-image">
        {product.images && product.images.length > 0 ? (
          <img src={product.images[0].url} alt={product.name} />
        ) : (
          <div className="placeholder-image">
            <p>Image Coming Soon</p>
          </div>
        )}
        <span className="status-badge working">Undetected</span>
      </div>
      <div className="product-info">
        <h3 className="product-title">
          {product.title || product.name || 'Product'}
          <span className="variant-count">{getVariantCount()}</span>
        </h3>
        <p className="product-description">
          {product.description ? 
            (product.description.length > 120 ? 
              product.description.substring(0, 120) + '...' : 
              product.description) : 
            'Premium gaming tool with all features included.'}
        </p>
        <div className="product-footer">
          <span className="product-price">${getPrice()}</span>
          <span className="product-link-text">View Details →</span>
        </div>
      </div>
    </Link>
  );
}

export default Products;
